export default __webpack_public_path__ + "static/media/9.ab3192a7.jpg";